import { render, staticRenderFns } from "./LimitModal.vue?vue&type=template&id=2f8500b1&scoped=true"
import script from "./LimitModal.vue?vue&type=script&lang=js"
export * from "./LimitModal.vue?vue&type=script&lang=js"
import style0 from "./LimitModal.vue?vue&type=style&index=0&id=2f8500b1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8500b1",
  null
  
)

export default component.exports